import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { db } from '../Config/Config';
import { addDoc, collection, doc, getDoc } from 'firebase/firestore';
import { useEffect, useState } from 'react';

const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};
const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12 } },
};

const Contact = () => {
  const { pathname } = useLocation();
  const [homeData, setHomeData] = useState(null);
  const isStandalone = pathname === '/contact';
  const sectionProps = isStandalone
    ? { variants: stagger, initial: 'hidden', animate: 'visible' }
    : { variants: stagger, initial: 'hidden', whileInView: 'visible', viewport: { once: true, amount: 0.1 } };
  const childProps = { variants: fadeUp };

    const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
 const [loading, setLoading] = useState(false);
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      await addDoc(
        collection(db, "website-management", "messages", "data"),
        {
          name: form.name,
          email: form.email,
          subject: form.subject,
          message: form.message,
          createdAt: new Date(),
        }
      );

      alert("Message sent successfully!");
      setLoading(false);
      setForm({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (err) {
      console.error("Error sending message:", err);
      alert("Something went wrong. Try again!");
      setLoading(false);
    }
  };
useEffect(() => {
    const getData = async () => {
      const ref = doc(db, "website-management", "contact");
      const snap = await getDoc(ref);

      if (snap.exists()) {
        setHomeData(snap.data());
      } else {
        console.log("home-page document not found");
      }
    };

    getData();
   
   
  }, []);
  return (
    <motion.section className="py-12" {...sectionProps}>
      {/* Heading */}
      <div className="text-center mb-8">
        <motion.h1 {...childProps} className="mt-3 text-3xl md:text-4xl font-bold text-brand-primary/90">Contact</motion.h1>
        <motion.p {...childProps} className="mt-2 text-slate-600 max-w-2xl mx-auto">We'd love to hear from you. Send us a message and our team will respond as soon as possible.</motion.p>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-8 items-start">
        {/* Info card */}
        <motion.div {...childProps} className="bg-white rounded-xl shadow-soft border border-slate-200 p-6">
          <h2 className="text-xl font-semibold text-slate-900">Office</h2>
          <p className="mt-2 text-slate-700">{homeData?.address}</p>
          <div className="mt-4 space-y-2 text-slate-700">
            <p><span className="font-medium">Email:</span> <a href={`mailto:${homeData?.email}`}  className="text-brand-primary">{homeData?.email}</a></p>
            <p><span className="font-medium">Phone:</span>{homeData?.phone}</p>
            <p><span className="font-medium">Hours:</span> {homeData?.workinghrs}</p>
          </div>
          <div className="mt-6 h-56 rounded-lg overflow-hidden border border-slate-200">
            <iframe
              title="Map"
              className="w-full h-full"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d0!2d76.307!3d10.026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1700000000000"
            />
          </div>
        </motion.div>

        {/* Form card */}
        <motion.div {...childProps} className="bg-white rounded-xl shadow-soft border border-slate-200 p-6">
          <h2 className="text-xl font-semibold text-slate-900">Send a message</h2>
          <form onSubmit={handleSubmit} className="mt-5 grid sm:grid-cols-2 gap-4">
            <input name="name" onChange={handleChange} value={form.name} className="border border-slate-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand-primary/50 focus:border-brand-primary placeholder-slate-400" placeholder="Name" />
            <input name="email" onChange={handleChange} type='email' value={form.email} className="border border-slate-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-brand-primary/50 focus:border-brand-primary placeholder-slate-400" placeholder="Email" />
            <input name="subject" onChange={handleChange} value={form.subject} className="border border-slate-300 rounded-lg px-4 py-3 sm:col-span-2 focus:outline-none focus:ring-2 focus:ring-brand-primary/50 focus:border-brand-primary placeholder-slate-400" placeholder="Subject" />
            <textarea name="message" onChange={handleChange} value={form.message} className="border border-slate-300 rounded-lg px-4 py-3 sm:col-span-2 focus:outline-none focus:ring-2 focus:ring-brand-primary/50 focus:border-brand-primary placeholder-slate-400" placeholder="Message" rows={6} />
            <div className="sm:col-span-2 flex items-center justify-between">
              <p className="text-xs text-slate-500">We respect your privacy. Your information is safe with us.</p>
              <button type="submit" className="bg-gradient-to-r from-brand-primary to-brand-dark text-white rounded-lg px-6 py-3 shadow-soft hover:shadow-md transition-shadow">{loading ? 'Sending...' : 'Send message'}</button>
            </div>
          </form>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Contact;
